module.exports = __webpack_public_path__ + "static/exotic-d5b8ebc05378973aae8f93108e0a02a1.png";